// @flow

export { DisplaySencillitoBrand } from './display-sencillito';
